import React, { useState, useEffect, StrictMode, useCallback, useRef } from 'react'
import {Form, Button, DropdownButton, Dropdown, ProgressBar, Offcanvas} from "react-bootstrap";
import axios from 'axios';
import * as signalR from "@microsoft/signalr";
import { Container } from 'reactstrap';
import '../account/Drones.css';
import Modem from '../account/Modem';
import ConsoleBindCard from './ConsoleBindCard';
import Bind from '../account/Bind';
import SortCard from '../account/SortCard';
import ConsoleNavMenu from './ConsoleNavMenu';
import ConsoleModemCard from './ConsoleModemCard';
import ConsoleBind from './ConsoleBind';
import './Console.css';
import ConsoleMap from './ConsoleMap';
import StatusText from './StatusText';
import Account from './Account';
import NavigationData from './NavigationData';
import ModemSettings from './ModemSettings'
import UserSettings from './UserSettings';
import { createImmediatelyInvokedFunctionExpression } from 'typescript';
import WebRtc from './webRtc/WebRtc';



function Console(){
    const protocol = new signalR.JsonHubProtocol();
    const transport = signalR.HttpTransportType.WebSockets;

    const [login, setLogin] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [missionPlannerUrl, setMissionPlannerUrl] = useState("");

    const [drone, setDrone] = useState(null);
    const [mapFocusOnDrone, setMapFocusOnDrone] = useState(null);
    const [drones, setDrones] = useState([]);
    const [isOnline, setIsOnline] = useState(false);
    const [isConfirmEmail, setIsConfirmEmail] = useState(false)
    const [isNebosvodAuth, setIsNebosvodAuth] = useState(false)
    const [nebosvodAuthLogin, setNebosvodLogin] = useState("")
    const [startMsgs, setStartMsgs] = useState([]);

    const [isLoad, setIsLoad] = useState(false);
    const [isBind, setIsBind] = useState(false);
    const [modemCardOnlineTop, setModemCardOnlineTop] = useState(false);

    const [updateOnlineDroneFromHub, setUpdateDroneFromHub] = useState(null);
    const [updateHbFromHub, setUpdateHbFromHub] = useState(null);

    const [showMsgs, setShowMsgs] = useState(false);

    const [showMenu, setShowMenu] = useState(false);
    const handleCloseMenu = useCallback(() => {setShowMenu(false); console.log("handle close menu")}, []);
    const toggleShowMenu = useCallback(() => {setShowMenu((s) => !s); console.log("show menu:"); console.log(showMenu);}, []);

    const [showUserSettings, setShowUserSettings] = useState(false);
    const handleCloseUserSettings = useCallback(() => {setShowUserSettings(false); console.log("handle close user settings")}, []);
    const toggleShowUserSettings = useCallback(() => {setShowUserSettings((s) => !s); console.log("show user settings:"); console.log(showMenu);}, []);
    const consoleNavMsgClick = useCallback(() => {setShowMsgs((s) => !s)}, []);


    const [hubTest, setHubTest] = useState(hubConnect);

    const modemCardRefs = useRef({});

    useEffect(() => {
        axios.get('api/user/start')
          .then(response => {
            setLogin(response.data.login);
            setIsAdmin(response.data.isAdmin);
            setMissionPlannerUrl(response.data.missionPlannerUrl);
            console.log(response);
          })
          .catch((error) => {console.log(error.response)});
        }, [window.location.href]);

    useEffect(() => {
        console.log("drone mount");
        getDronesInfo()
    }, []);

    useEffect(() => {
        if(updateOnlineDroneFromHub != null){
            var ddd = drones.map(d => 
                {
                    var temp = Object.assign({}, d);
                    if(updateOnlineDroneFromHub.imei === temp.imei){
                        temp.isOnline = updateOnlineDroneFromHub.isOnline
                    }
                    return temp;
                }
            );
            //console.log(ddd);
            setDrones(ddd);
        } 
    }, [updateOnlineDroneFromHub]);

    useEffect(() => {
        if(drones.length > 8){
            setModemCardOnlineTop(true);
        }
    }, [drones]);

    useEffect(() => {
        if(updateHbFromHub != null){
            var update = false;
            var ddd = drones.map(d => 
                {
                    
                    var temp = Object.assign({}, d);
                    if(updateHbFromHub.imei === temp.imei){
                        if(updateHbFromHub.isArm != temp.isArm)
                        {
                            //todo: refresh only arm
                            update = true;
                        }
                        temp.isArm = updateHbFromHub.isArm;
                        temp.mode = updateHbFromHub.mode;
                    }
                    /*if(drone?.imei === temp.imei) {
                        setDrone(temp);
                        console.log('Set drone tmp:')
                        console.log(temp);
                    }*/
                    return temp;
                }
            );
            //console.log(ddd);
            if(update === true) {
                setDrones(ddd);
            }
        } 
    }, [updateHbFromHub]);

    useEffect(() => {
        return () => {
            console.log("drone.js unmount");
            hubTest.stop();
        };
    }, []);

    function getDronesInfo(){
        axios.get('api/drone/getModems')
        .then(response => {
            console.log("drone:"); 
            console.log(response.data);
            setDrones(response.data.modemsInfo);
            setIsConfirmEmail(response.data.isConfirmEmail)
            setIsNebosvodAuth(response.data.isNebosvodAuth)
            setNebosvodLogin(response.data.nebosvodLogin)
            setStartMsgs(response.data.startMsgs)
            setIsLoad(true);
        })
        .catch(ex => {
            console.log(ex);
            if(ex.response.status === 401) {
                window.location = "/login";
            }
        });
    }

    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;
        connection.on('SetOnline', (message) => 
        {
            //console.log("hub: SetOnline"); 
            setUpdateDroneFromHub(message);
        });

        connection.on('HbStatus', (message) =>
        {
            //console.log("hub: HbStatus");
            setUpdateHbFromHub(message);
        });

        connection.start();
        return connection;
    }

    const nebosvodLogin = useCallback((nebosvodLogin) => {
        setIsNebosvodAuth(true)
        setNebosvodLogin(nebosvodLogin)
        console.log("nebosvod login: " + nebosvodLogin)
    }, []);

    const modemCardClick = useCallback((imei) => {
        const selected = drones.find(d => d.imei === imei);
        if (selected) {
          setIsBind(false); 
          setDrone(selected);
          setMapFocusOnDrone({});
        }
      }, [drones]);
    
    const markerClick = useCallback((imei) => {
        const selected = drones.find(d => d.imei === imei);
        if (selected) {
          setIsBind(false); 
          setDrone(selected);
          scrollToModemCard(imei);
        }
    }, [drones]);

    const scrollToModemCard = (imei) => {
        const el = modemCardRefs.current[imei];
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };

    const callback = (id, phase, actualTime, baseTime, startTime, commitTime) => {
        console.log(`${id}'s ${phase} phase: Actual: ${actualTime} ms`);
    }

    return(
        <>
        { drone == null ? <ConsoleNavMenu drone={null} toggleShowUserSettings={toggleShowUserSettings} isAdmin={isAdmin} missionPlannerUrl={missionPlannerUrl} login={login}/> : <ConsoleNavMenu drone={drone} toggleShowMenu={toggleShowMenu} toggleShowUserSettings={toggleShowUserSettings} showMsgsAct={consoleNavMsgClick} startMsgs={startMsgs} isAdmin={isAdmin} missionPlannerUrl={missionPlannerUrl} login={login}/>}

        <div className='console-blocks'>
            <div className='console-drones'>
                <ConsoleMap currentDrone={drone} udpateFocus={mapFocusOnDrone} markerClick={markerClick}/>
                <div className='console-modem-cards'>
                    {/*drones.length > 4 ? <SortCard onlineTopClick={() => { onlineTopClick() }} /> : <></>*/}
                    {modemCardOnlineTop ?
                        drones.sort((x, y) => x.name.localeCompare(y.name, "pl")).sort(x => x.isOnline ? -1 : 1).map(d => 
                            <div key={d.imei} ref={el => modemCardRefs.current[d.imei] = el}>
                                <ConsoleModemCard 
                                    imei={d.imei}
                                    modemName={d.name}
                                    isOnline={d.isOnline}
                                    isActive={drone?.imei === d.imei}
                                    version={d.version}
                                    update={d.isLastFirmware}
                                    upgrade={d.upgradable}
                                    isArm={d.isArm}
                                    mavType={d.mavType}
                                    onClick={modemCardClick}
                                />
                            </div>) 
                        : 
                        drones.map(d => 
                            <div key={d.imei} ref={el => modemCardRefs.current[d.imei] = el}>
                                <ConsoleModemCard 
                                    imei={d.imei}
                                    modemName={d.name}
                                    isOnline={d.isOnline}
                                    isActive={drone?.imei === d.imei}
                                    version={d.version}
                                    update={d.isLastFirmware}
                                    upgrade={d.upgradable}
                                    isArm={d.isArm}
                                    mavType={d.mavType}
                                    onClick={modemCardClick}
                                />
                            </div>)
                    }
                    <ConsoleBindCard onClick={() => {setIsBind(true); setDrone(null);}}/>
                </div>

                <StatusText drone={drone} showMsgs={showMsgs} startMsgs={startMsgs} />
                {<WebRtc drone={drone}/>}
                <NavigationData drone={drone}/>

                <Offcanvas show={showUserSettings} onHide={handleCloseUserSettings} name="User Settings" placement='end'>
                    <Offcanvas.Body>
                        <UserSettings isConfirmEmail={isConfirmEmail} isAdmin={isAdmin} login={login} missionPlannerUrl={missionPlannerUrl}/>
                    </Offcanvas.Body>
                </Offcanvas>

                {isLoad ? 
                <>
                    {isBind | (drone == null || drone.imei == null) ? 
                    <ConsoleBind/>
                    : 
                    <Offcanvas show={showMenu} onHide={handleCloseMenu} name="test name" placement='end'>
                        <Offcanvas.Body>
                            <ModemSettings drone={drone} isNebosvodAuth={isNebosvodAuth} nebosvodAuthLogin={nebosvodAuthLogin} onNebosvodAuth={nebosvodLogin}/>
                        </Offcanvas.Body>
                    </Offcanvas>
                    }
                    
                </>
                :
                <>
                </>
                }
            </div>
        </div>
        </>
    )
}
    

export default Console;
